module.exports = __webpack_public_path__ + "img/Twitter.1aa2ab08.svg";